import React, { useState } from "react";

import IconButton from "@mui/material/IconButton";
import ShoppingCartTwoToneIcon from "@mui/icons-material/ShoppingCartTwoTone";

import { CustomTooltip } from "../customtooltip/CustomTooltip";

import AITestContext from "../../../contexts/AITestContext";
import StatusContext from "../../../contexts/StatusContext";
import AuthContext from "../../../contexts/AuthContext";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {StripePaymentForm} from './StripePaymentForm'

import { config } from "../../../config";


// IMPORTANT:
// Make sure this variable actually exists in your .env file.
//
// For Create React App:
// REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_....
//
// For Vite it would be:
// import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
//
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);


export const SchoolYearCourses = ({
  courses,
  scrollreference
}) => {

  const [hoveredIndex, setHoveredIndex] = useState(-1);

  const [showPayment, setShowPayment] = useState(false);

  const [clientSecret, setClientSecret] = useState(null);

  const [buyingItem, setBuyingItem] = useState(null);

  const [paymentLoading, setPaymentLoading] = useState(false);


  // --------------------------------------------------
  // STATUS CONTEXT
  // --------------------------------------------------

  const {
    changeTestLanguage,
    setShowLoginDialog
  } = React.useContext(StatusContext);


  // --------------------------------------------------
  // AUTH CONTEXT
  // --------------------------------------------------

  const {
    currentUser,
    checkCurrentUser,
  } = React.useContext(AuthContext);


  // --------------------------------------------------
  // AI TEST CONTEXT
  // --------------------------------------------------

  const {
    onSelectCourse,
    universities,
    universityindex,
    collegeindex,
    showschoolyearcourses,
    isSchoolTestBought,
    saveBoughtIndividualCollegeTests,
    boughtcourse,
    setBoughtCourse,
    collegeindividualtestprice, 
    
  } = React.useContext(AITestContext);


  // --------------------------------------------------
  // STYLES
  // --------------------------------------------------

  const styles = {

    item: {

      alignItems: "center",

      textAlign: "center",

      color: "maroon",

      borderRadius: "5px",

      padding: "5px",

      marginBottom: "10px",

      width: "100%",

      border: "none",

      cursor: "pointer",

      backgroundColor: (index) =>
        hoveredIndex === index
          ? "rgb(122, 207, 235)"
          : "lightblue",

      transition: "background-color 0.3s ease"
    }
  };


  // --------------------------------------------------
  // BUY COURSE
  // --------------------------------------------------

  const handleBuy = (item) => async (e) => {

    // Very important because the parent <div>
    // also has an onClick handler.
    e.stopPropagation();

    console.log("handleBuy Individual College Course:", item);

    if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }
    // ------------------------------------------------
    // Check that context data exists
    // ------------------------------------------------

    if (!universities ||
        universities.length === 0 ||
        universityindex == null ||
        collegeindex == null) {

      console.error(
        "University/college information is missing"
      );

      return;
    }


    const university =
      universities[universityindex].university;


    const schoolname =
      universities[universityindex]
        .college[collegeindex]
        .name;


    const schoolyear =
      showschoolyearcourses;


    console.log("university:", university);
    console.log("schoolname:", schoolname);
    console.log("schoolyear:", schoolyear);
    console.log("course:", item);
    console.log("currentUser:", currentUser);

    setBoughtCourse(item)


    // ------------------------------------------------
    // Show payment area
    // ------------------------------------------------

    setBuyingItem(item);

    setPaymentLoading(true);

    setShowPayment(true);


    try {

      // ------------------------------------------------
      // Create PaymentIntent on your SERVER
      // ------------------------------------------------

      const response = await fetch(

        config.url.API_URL +
        "/deda_ai_api/pay/buycollegeindividualcoursetestsintent",

        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({

            university: university,

            schoolname: schoolname,

            schoolyear: schoolyear,

            course: item,

            user: currentUser,


            // Price is set on the server side
           
          
          })
        }
      );


      const data = await response.json();


      console.log(
        "buytestintent response:",
        data
      );


      if (!response.ok) {

        throw new Error(
          data.message ||
          "Unable to create payment"
        );
      }


      if (!data.clientSecret) {

        throw new Error(
          "Server did not return clientSecret"
        );
      }


      // ------------------------------------------------
      // Stripe PaymentIntent client secret
      // ------------------------------------------------

      setClientSecret(
        data.clientSecret
      );


    } catch (error) {

      console.error(
        "Payment initialization error:",
        error
      );

      console.log("It is OK")
      setShowPayment(false);

      setBuyingItem(null);

      setClientSecret(null);


    } finally {

      setPaymentLoading(false);

    }

  };


  // --------------------------------------------------
  // CANCEL PAYMENT
  // --------------------------------------------------

  const handlePaymentCancel = () => {

    setShowPayment(false);

    setClientSecret(null);

    setBuyingItem(null);

  };


  // --------------------------------------------------
  // PAYMENT SUCCESS
  // --------------------------------------------------

  const handlePaymentSuccess = () => {

    console.log(
      "Stripe payment completed - Bought Individual Course Tests"
    );

    saveBoughtIndividualCollegeTests(boughtcourse)

    setShowPayment(false);

    setClientSecret(null);

    setBuyingItem(null);



  };


  // --------------------------------------------------
  // RENDER
  // --------------------------------------------------

  return (

    <div>

      {Array.isArray(courses) &&

        courses.map((item, index) => (

          <div
            key={index}

            className="schoolyearcourse"

            style={{
              ...styles.item,

              backgroundColor:
                isSchoolTestBought(item)
                  ? "#28a745"
                  : styles.item.backgroundColor(index),

              color:
                isSchoolTestBought(item)
                  ? "white"
                  : "maroon"
            }}

            onMouseEnter={() =>
              setHoveredIndex(index)
            }

            onMouseLeave={() =>
              setHoveredIndex(-1)
            }

            onClick={() => {

              onSelectCourse(item);

              scrollreference.current?.scrollIntoView({
                behavior: "smooth",
                block: "start"
              });

            }}
          >

            {/* ====================================== */}
            {/* COURSE NAME + SHOPPING CART             */}
            {/* ====================================== */}

            <div
              style={{
                display: "flex",

                justifyContent: "space-between",

                alignItems: "center",

                width: "100%"
              }}
            >

              <span>
                {item}
              </span>


              {!isSchoolTestBought(item) && (

                <IconButton

                  onClick={handleBuy(item)}

                  size="small"

                  sx={{
                    padding: "2px",

                    margin: 0,

                    color: "maroon",

                    backgroundColor: "white",

                    "&:hover": {
                      backgroundColor: "#f0f0f0"
                    }
                  }}
                >

                  <CustomTooltip
                    title={changeTestLanguage(
                      "aitest",
                      "buytest"
                    )}
                  >

                    <span>

                      <ShoppingCartTwoToneIcon
                        sx={{
                          fontSize: "30px",
                          padding: "6px",
                          color:'green'
                        }}
                      />

                    </span>

                  </CustomTooltip>

                </IconButton>

              )}

            </div>


            {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}


            {/* ====================================== */}
            {/* STRIPE PAYMENT FORM                    */}
            {/* ====================================== */}

            {showPayment &&
              buyingItem === item &&
              clientSecret && (

                <div

                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    marginTop: "15px",

                    padding: "15px",

                    backgroundColor: "#f5f5f5",

                    borderRadius: "8px",

                    width: "100%",

                    boxSizing: "border-box"
                  }}
                >

                  <Elements

                    stripe={stripePromise}

                    options={{
                      clientSecret:
                        clientSecret,

                      appearance: {
                        theme: "stripe"
                      },
                    }}
                  >

                    <StripePaymentForm

                      clientSecret={
                        clientSecret
                      }
                      
                      price={collegeindividualtestprice}

                      onSuccess={
                        handlePaymentSuccess
                      }

                      onCancel={
                        handlePaymentCancel
                      }

                    />

                  </Elements>

                </div>

              )}

          </div>

        ))

      }

    </div>

  );

};


export default SchoolYearCourses;